import styled from '@emotion/styled';

export const AccordionContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

export const AccordionHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	padding: var(--padding-3);
	color: var(--black);
	background-color: var(--white);
	border: 1px solid var(--black-10);
	border-top-left-radius: var(--spacing-1);
	border-top-right-radius: var(--spacing-1);
	transition: background-color 0.6s ease;

	:not(&.expanded) {
		border-bottom-left-radius: var(--spacing-1);
		border-bottom-right-radius: var(--spacing-1);
	}

	> .expand-icon > svg {
		transition: all 0.6s ease;
	}

	&.expanded {
		border-bottom: 1px solid var(--black-10);

		> .expand-icon > svg {
			transform: scale(1, -1);
		}
	}

	:hover,
	&.expanded {
		background-color: var(--background-3);
	}

	.info-icon {
		margin-left: var(--spacing-1);

		body[dir='rtl'] & {
			margin-left: 0;
			margin-right: var(--spacing-1);
		}
	}
`;

export const AccordionContentContainer = styled.div`
	background-color: var(--white);
	border-right: 1px solid var(--black-10);
	border-left: 1px solid var(--black-10);
	border-bottom: 1px solid var(--black-10);
	border-bottom-left-radius: var(--spacing-1);
	border-bottom-right-radius: var(--spacing-1);
	padding: var(--padding-3);
	color: var(--black);
	overflow: hidden;
`;
